<template>
    <div class="user-api">
        <el-form ref="form" :model="userProfile" :rules="rules">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item prop="pepper_broker_email" label="Pepper Broker Username (Solana)">
                        <el-input :disabled="saving" v-model="userProfile.pepper_broker_email"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="latitude_broker_id" label="Latitude Broker ID">
                        <el-input :disabled="saving" v-model="userProfile.latitude_broker_id"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item prop="liberty_broker_id" label="Liberty Broker ID">
                        <el-input :disabled="saving" v-model="userProfile.liberty_broker_id"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="money3_broker_id" label="Money3 Broker ID">
                        <el-input :disabled="saving" v-model="userProfile.money3_broker_id"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item prop="finance_one_broker_id" label="Finance One Broker ID">
                        <el-input :disabled="saving" v-model="userProfile.finance_one_broker_id"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="macquarie_broker_token" label="Macquarie Broker Token">
                        <el-input :disabled="saving" v-model="userProfile.macquarie_broker_token"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item prop="ume_loans_broker_token" label="Ume Loans Broker Token">
                        <el-input :disabled="saving" v-model="userProfile.ume_loans_broker_token"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="metro_username" label="Metro Broker ID">
                        <el-col :span="24" v-if="!userProfile.metro_username">
                            <el-button type="warning" :disabled="metro.loading" @click="metro.show = true">Connect Metro
                                API
                            </el-button>
                        </el-col>
                        <el-col :span="24" v-else>
                            <el-col :span="12">
                                <span>{{ userProfile.metro_username }}</span>
                            </el-col>
                            <el-col :span="12" class="text-right">
                                <el-button type="danger" :disabled="metro.loading" @click="disconnectMetro">Disconnect
                                </el-button>
                            </el-col>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item prop="wisr_partner_id" label="Wisr Partner ID">
                        <el-input :disabled="saving" v-model="userProfile.wisr_partner_id"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="green_light_auto_user_id" label="Green Light Auto User ID">
                        <el-input :disabled="saving" v-model="userProfile.green_light_auto_user_id"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item prop="nowfinance_broker_token" label="Now Finance Broker Token">
                        <el-input :disabled="saving" v-model="userProfile.nowfinance_broker_token"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="firstmac_broker_id" label="FirstMac Broker ID">
                        <el-input :disabled="saving" v-model="userProfile.firstmac_broker_id"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="firstmac_contact_id" label="FirstMac Contact ID">
                        <el-input :disabled="saving" v-model="userProfile.firstmac_contact_id"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div class="fin-flex fin-justify-between fin-items-center">
            <el-button
                class="mt-5"
                ref="saveLenderSettings"
                :disabled="saving"
                type="primary"
                @click="saveLenderSettings">{{ saveText }}
            </el-button>

            <el-button
                class="mt-5"
                ref="getWisrPartnerId"
                :disabled="loadingWisrPartnerId"
                :loading="loadingWisrPartnerId"
                type="primary"
                @click="getWisrPartnerId">{{ 'Get Wisr Partner ID' }}
            </el-button>
        </div>

        <x-modal
            v-if="metro.show"
            width="650"
            okText="Connect"
            :draggable="true"
            :okDisabled="metro.loading"
            :loading="metro.loading"
            @close="metro.show = false"
            @cancel="metro.show = false"
            @ok="connectMetro"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">Metro API Connect</div>
            <div class="container"> <!-- style="max-height: 50vh; overflow-y: scroll" -->
                <el-form :model="metro" status-icon :rules="metro.rules" ref="metroForm" label-position="top">
                    <el-form-item>
                        <small>Enter your Metro Finance username &amp; password to connect Ambition to Metro
                            API.</small>
                    </el-form-item>
                    <el-form-item label="Username" prop="username">
                        <el-input type="text" v-model="metro.username" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Password" prop="pass">
                        <el-input type="password" v-model="metro.pass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Confirm" prop="checkPass">
                        <el-input type="password" v-model="metro.checkPass" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </x-modal>
    </div>
</template>

<script>
export default {
    name: "UserLenderSettings",

    data() {
        return {
            saving: false,
            loadingWisrPartnerId: false,
            saveText: "Save Lender Settings",
            metro: {
                show: false,
                loading: false,
                username: '',
                pass: '',
                checkPass: '',
                rules: {
                    username: [{required: true, trigger: 'blur'}],
                    pass: [{required: true, validator: this.validatePass, trigger: 'blur'}],
                    checkPass: [{required: true, validator: this.validatePass2, trigger: 'blur'}],
                }
            },
            rules: {
                // first_name: [{ required: true, message: "Required", trigger: "blur" }],
                // last_name: [{ required: true, message: "Required", trigger: "blur" }],
                // phone: [{ required: true, message: "Required", trigger: "blur" }],
                // timezone: [{ required: true, message: "Required", trigger: "change" }],
            },
        }
    },

    computed: {
        userProfile: {
            get() {
                return this.$store.getters['user/user']
            },
            set(profile) {
                this.$store.dispatch('user/setUser', profile)
            }
        },
        timezones() {
            return this.$store.getters['user/timezones']
        }
    },

    methods: {
        getWisrPartnerId() {
            this.loadingWisrPartnerId = true
            axios.get(`/admin/get-wisr-partner-id`, {
                params: {
                    tenant: Ambition.tenantId(),
                    email: _.get(this.userProfile, 'email')
                }
            })
                .then(response => {
                    this.$notify({
                        title: 'Success!',
                        message: 'Wisr Partner Id Retrieved Successfully'
                    });
                })
                .catch(err => {
                    this.$notify({
                        title: 'Error!',
                        message: _.get(err, 'response.data.errors')
                    });
                })
                .finally(() => {
                    this.loadingWisrPartnerId = false
                })
        },
        saveLenderSettings() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.saving = true
                    this.saveText = "Saving..."
                    axios.post('/admin/account/save-lender-settings', this.userProfile)
                        .then(response => {
                            this.$notify({
                                title: 'Saved!',
                                message: 'Lender settings was updated.'
                            });
                        })
                        .catch(err => {
                            this.$notify({
                                title: 'Error!',
                                message: 'There was an error while updating the lender settings. Please contact support.'
                            });
                        })
                        .finally(() => {
                            this.saving = false
                            this.saveText = "Save Lender Settings"
                        })
                }
            })
        },
        connectMetro() {
            this.$refs.metroForm.validate((valid) => {
                if (valid) {
                    this.metro.loading = true;
                    this.$tenant.post('/admin/account/metro-connect', {
                        username: this.metro.username,
                        pass: this.metro.pass
                    })
                        .then((response) => {
                            this.$notify({
                                type: 'success',
                                title: 'Metro API',
                                message: 'Successfully connected!'
                            })
                            this.metro.show = false
                            this.userProfile.metro_username = _.get(response, 'data.username')
                        })
                        .catch(err => {
                            err.output()
                            this.$notify({
                                type: 'error',
                                title: 'Metro API',
                                message: 'Failed to connect!'
                            })
                        })
                        .finally(() => {
                            this.metro.loading = false
                        })
                }
            })
        },
        disconnectMetro() {
            this.metro.loading = true;
            this.$tenant.get('/admin/account/metro-disconnect')
                .then((response) => {
                    this.userProfile.metro_username = null
                })
                .catch((error) => {
                    console.error(error)
                })
                .finally(() => {
                    this.metro.loading = false;
                })
        },
        validatePass(rule, value, callback) {
            if (value === '') {
                callback(new Error('Please input the password'));
            } else {
                if (this.metro.checkPass !== '') {
                    this.$refs.metroForm.validateField('checkPass');
                }
                callback();
            }
        },
        validatePass2(rule, value, callback) {
            if (value === '') {
                callback(new Error('Please input the password again'));
            } else if (value !== this.metro.pass) {
                callback(new Error('Confirm password doesn\'t match!'));
            } else {
                callback();
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.user-api {
    padding: 50px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
</style>
